import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Box, Drawer, IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';



const getDrawerWidth = (isSmallScreen: boolean) => isSmallScreen ? '100%' : '60%';


const InfoDrawer = (props: InfoDrawerProps) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const drawerWidth = getDrawerWidth(isSmallScreen);

    return (
        <Drawer
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: drawerWidth,
                    boxSizing: 'border-box',
                    padding: 0,
                    maxHeight: '100vh',
                    overflowY: 'auto'
                },
                '& .MuiBackdrop-root': {
                    touchAction: 'none'
                }
            }}
            anchor={isSmallScreen ? 'bottom' : 'right'}
            open={props.open}
            onClose={props.handleDrawerClose}
            SlideProps={{
                direction: isSmallScreen ? 'up' : 'left'
            }}
        >
            {/* Container with relative positioning */}
            <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
                {/* Close button */}
                <IconButton
                    aria-label="close"
                    onClick={props.handleDrawerClose}
                    sx={{
                        position: 'absolute',
                        right: isSmallScreen ? theme.spacing(1) : theme.spacing(2),
                        top: isSmallScreen ? theme.spacing(1) : theme.spacing(2),
                        color: (theme) => theme.palette.grey[500],
                        zIndex: theme.zIndex.drawer + 1,
                    }}
                >
                    <CloseIcon />
                </IconButton>

                {/* Outer Box for alignment */}
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center', // Center horizontally
                        pt: isSmallScreen ? 6 : 7,
                        px: isSmallScreen ? 2 : 3,
                        pb: 2,
                    }}
                >
                    {/* Inner Box for content with max-width */}
                    <Box
                        sx={{
                            width: '100%',
                            maxWidth: '100%', // You can adjust this value based on your needs
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            WebkitOverflowScrolling: 'touch',
                        }}
                    >
                         {props.information ? props.componentMap[props.information] ?? null : null}

                    </Box>
                </Box>
            </Box>
        </Drawer>
    );
};
interface InfoDrawerProps {
    open: boolean;
    handleDrawerClose: () => void;
    information: string | undefined;
    componentMap:  Record<string, JSX.Element>;
}

export default InfoDrawer;